import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Message extends Component {
	constructor(props) {
		super(props);
		this.messageAlert;
		this.state = {  
			message: false,
			messageStage: false     
		};
	  }


	componentDidMount() {
		this.messageAlert =  window.setTimeout(this.newMessage, 8000);
	}

	componentWillUnmount() {
		// window.removeEventListener("resize", this.updateDimensions.bind(this));
		// var mapHolder = document.getElementById('mapHolder');
		// mapHolder.classList.remove('featOn');
	   clearTimeout(this.messageAlert);
	  }

	newMessage(){
	  var hiddenMessage = document.getElementsByClassName('hideMessage');
	  if(hiddenMessage.length > 0){
	  hiddenMessage[0].classList.remove('hideMessage')
	  }
  }

	checkMessage(e){
		var hiddenMessage2 = document.getElementsByClassName('removeMessageStage');
		(!this.state.messageStage) ? (
			(hiddenMessage2.length > 0) ? (
				hiddenMessage2[0].classList.remove('removeMessageStage')
			):(''),
			e.currentTarget.classList.add('messageFullStage'),
			this.setState({messageStage:true})
		):(
			e.currentTarget.classList.remove('messageFullStage'),
			e.currentTarget.classList.add('removeMessageStage'),
			this.setState({messageStage:false})
		)
  }

	render() {
		return (
			<div className="messageStage relative hideMessage" onClick={this.checkMessage.bind(this)}>
				<div className="messageAlert centeredContent upperT boldT">
					<span className="smallMessageT">Want to donate</span> labor and/or skills?
				</div>
				<div className="messageHold centerT centeredContent">
					<div className="fullStage marginBotSmall featQuoteCopy">
					{/*<img src={} alt="chomskyProfile"></img>*/}
					<h2 className="fullStage marginBotSmall featQuoteCopy wT">We aren't just taking money, y'all.<br />If you're willing to help us save on costs and boost the work that we're doing through a donation of labor time and energy, hit us up through our contact form, letting us know what you do and how you can contribute. If you have a portfolio to share, please include it as well!</h2>
					{/*<p ><span className="titleFont boldT upperT marginBotSmall messageSender">{this.props.messageQuotes[0].quoteName}</span> <br/>on BSA’s Statement of Core Principles and Objectives</p>*/}
					<Link className="wT contactBut" to="/contact" onClick={this.props.manualMap.bind(this)} data-id="6" data-name="contact"><h3 >CONTACT US</h3></Link>
					<p className="titleFont boldT upperT blink messageDismiss">Tap to dismiss</p>
					</div>
				</div>
			</div>
		)
	}
}
  
export default Message;


// WEBPACK FOOTER //
// ./src/components/donate/message.js